import { defineStore } from 'pinia'
import _ from 'lodash'

export const useNewsStore = defineStore('news', {
	state: () => {
		return {
			articles: [],
		}
	},
	getters: {
		categories: (state) => {
			let allCategories = state.articles?.flatMap(({ category }) => category).filter(Boolean)
			let categories = [...new Set(allCategories.map((o) => JSON.stringify(o)))].map((string) => JSON.parse(string))
			return _.orderBy(categories, 'name', 'desc')
		},
	},
	actions: {
		setup() {
			this.getArticles()
		},
		getArticles() {
			return axios
				.get('/api/news')
				.then((articles) => {
					this.articles = articles.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
})
